module.exports = "/_next/static/images/bancontact-68308f8a5ab1c337e32d9164331ca30f.svg";